// 日历类
class Calendar {
  constructor(value = new Date()) {
    // 一些属性
    this.currentMonth = 6 // 当月
    this.currentYear = 2023 // 当年
    this.currentFirstWeekDay = 1 // 当月第一天是星期几
    this.renderCallback = null // 用户传入的render回调函数
    this.allDay = 31 // 本月多少天
    this.init(value) // 首次执行时，传入当前日期
  }

  init(date) {
    // date 参数，一个日期对象，日历改变就是操作日期，后面操作函数也会调用该方法
    this.currentYear = date.getFullYear()
    this.currentMonth = date.getMonth()
    this.currentFirstWeekDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      1
    ).getDay()
    this.currentFirstWeekDay =
      this.currentFirstWeekDay === 0 ? 7 : this.currentFirstWeekDay

    this.allDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  }

  checknowDay(year, month, day) {
    let date = new Date()
    let nowYear = date.getFullYear()
    let nowMonth = date.getMonth()
    let nowDay = date.getDate()
    if (nowYear === year && nowMonth === month && nowDay === day) {
      return true
    } else {
      return false
    }
  }

  makeUpZero(item) {
    return item < 10 ? '0' + item : item
  }

  getDayWeek(item) {
    let weekMap = ['日', '一', '二', '三', '四', '五', '六']
    return weekMap[new Date(item).getDay()]
  }

  getPrevMonthDay() {
    // 该函数用来获取日历中上月需显示的天数
    let date = new Date(this.currentYear, this.currentMonth, 0) // 获取上月；
    let day = date.getDate() // 因为Date函数中天设置的0，因此这里是上月最后一天的值
    let days = this.currentFirstWeekDay - 1 // 上月要显示几天
    let weeks = []
    while (days > 0) {
      let currentYear = date.getFullYear()
      let currentMonth = this.makeUpZero(date.getMonth() + 1)
      let currentDay = this.makeUpZero(day)
      let currentWeek = this.getDayWeek(
        `${currentYear}.${currentMonth}.${currentDay}`
      )
      weeks.push({
        year: currentYear,
        month: currentMonth,
        day: day,
        completeDay: `${currentYear}${currentMonth}${currentDay}`,
        week: currentWeek,
        type: 'prev' // 用于标记这是上月的，可以配合渲染对处理，比如置灰啥的
      })
      day--
      days--
    }
    return weeks.sort((a, b) => a.day - b.day) // 因为是从大到小的，排个序
  }

  getNowMonthDay() {
    // 该函数用来获取日历中本月需显示的天数
    let days = this.allDay
    let weeks = []
    let day = 0
    while (days > 0) {
      day++
      let check = this.checknowDay(this.currentYear, this.currentMonth, day)
      let currentYear = this.currentYear
      let currentMonth = this.makeUpZero(this.currentMonth + 1)
      let currentDay = this.makeUpZero(day)
      let currentWeek = this.getDayWeek(
        `${currentYear}.${currentMonth}.${currentDay}`
      )
      weeks.push({
        year: currentYear,
        month: currentMonth,
        day: day,
        completeDay: `${currentYear}${currentMonth}${currentDay}`,
        week: currentWeek,
        type: check ? 'current' : '' // 判断当月某一天是不是现实中当天对应
      })
      days--
    }
    return weeks
  }

  getNextMonthDay() {
    // 该函数用来获取日历中下月需显示的天数
    let days = 35 - this.currentFirstWeekDay - this.allDay + 1
    let date = new Date(this.currentYear, this.currentMonth + 1, 1) // 获取下月
    let weeks = []
    let day = 1
    while (days > 0) {
      let currentYear = date.getFullYear()
      let currentMonth = this.makeUpZero(date.getMonth() + 1)
      let currentDay = this.makeUpZero(day)
      let currentWeek = this.getDayWeek(
        `${currentYear}.${currentMonth}.${currentDay}`
      )
      day++
      weeks.push({
        year: currentYear,
        month: currentMonth,
        day: day,
        completeDay: `${currentYear}${currentMonth}${currentDay}`,
        week: currentWeek,
        type: 'next'
      })
      days--
    }
    return weeks
  }

  // 操作函数
  prevMonth(fn) {
    if (this.currentMonth === 0) {
      this.currentMonth = 11
      this.currentYear--
    } else {
      this.currentMonth--
    }
    this.init(new Date(this.currentYear, this.currentMonth))
    this.render(this.renderCallback)
    fn(this.currentYear, this.makeUpZero(this.currentMonth + 1))
  }

  nextMonth(fn) {
    if (this.currentMonth === 11) {
      this.currentMonth = 0
      this.currentYear++
    } else {
      this.currentMonth++
    }
    this.init(new Date(this.currentYear, this.currentMonth))
    this.render(this.renderCallback)
    fn(this.currentYear, this.makeUpZero(this.currentMonth + 1))
  }

  prevYear(fn) {
    this.currentYear--
    this.init(new Date(this.currentYear, this.currentMonth))
    this.render(this.renderCallback)
    // fn(this.currentYear, this.currentMonth)
  }

  nextYear(fn) {
    this.currentYear++
    this.init(new Date(this.currentYear, this.currentMonth))
    this.render(this.renderCallback)
    // fn(this.currentYear, this.currentMonth)
  }

  // 渲染函数，用户新建一个实例后必须使用此函数获取最新的日期数据，接收一个回调函数
  render(fn) {
    if (typeof fn !== 'function') {
      throw new Error('参数必须是个函数')
    }
    let weeks = [
      ...this.getPrevMonthDay(),
      ...this.getNowMonthDay(),
      ...this.getNextMonthDay()
    ]
    fn(weeks, this.currentYear, this.makeUpZero(this.currentMonth + 1))
    // let data = []
    // let count = []
    // 这里的操作是把1维数组转成二维数组
    // for (let i = 0; i < weeks.length; i++) {
    //   if (count.length === 6) {
    //     count.push(weeks[i])
    //     data.push(count)
    //     count = []
    //   } else {
    //     count.push(weeks[i])
    //   }
    // }
    // fn(data)
    // 一定要保存用户传入的函数，这要操作函数调用时能使用它
    if (!this.renderCallback) {
      this.renderCallback = fn
    }
  }
}
export default Calendar
